import { RegistryWidgetElement } from './registry-widget'

/**
 * `<gs-cc-ai-widget>` — a widget whose html (+ css + js) bundle is authored via the
 * AI builder. At runtime it is just a registry widget: first paint hydrates from the
 * SSR declarative-shadow-DOM `<template>` (inherited, unchanged), and the `content`
 * property optionally *progresses* that bundle client-side.
 *
 * `content` re-mounts the bundle (clean teardown → inject → run scripts) using the
 * base's shared primitives — the host just assigns rich data to a property
 * (`el.content = html`) rather than firing an event, and the markup never round-trips
 * to the server because it is already in memory.
 */
export class AiWidgetElement extends RegistryWidgetElement {
  private currentContent = ''

  get content(): string {
    return this.currentContent
  }

  set content(html: string) {
    this.currentContent = html ?? ''

    const shadowRoot = this.shadowRoot
    if (!shadowRoot) {
      // Not hydrated yet — the injected <template> provides the first paint.
      return
    }

    this.resetShadowRoot(shadowRoot)
    this.renderContent(shadowRoot, this.currentContent)
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('gs-cc-ai-widget')) {
  customElements.define('gs-cc-ai-widget', AiWidgetElement)
}
